import { render, staticRenderFns } from "./RechargeCombo.vue?vue&type=template&id=2b22a91a&scoped=true&"
import script from "./RechargeCombo.vue?vue&type=script&lang=js&"
export * from "./RechargeCombo.vue?vue&type=script&lang=js&"
import style0 from "./RechargeCombo.vue?vue&type=style&index=0&id=2b22a91a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b22a91a",
  null
  
)

export default component.exports